/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFollows.defs.js'
export * as $defs from './getFollows.defs.js'
